import type { ReactNode } from 'react';

import { Suspense } from '@sorare/core/src/atoms/Suspense';
import { Horizontal } from '@sorare/core/src/atoms/layout/flex';
import { UserNav } from '@sorare/core/src/components/navigation/UserNav';
import { useSportContext } from '@sorare/core/src/contexts/sport';
import { useSeriesNav } from '@sorare/core/src/hooks/commonGame/useSeriesNav';
import { lazy } from '@sorare/core/src/lib/retry';
import { css } from '@sorare/css';

import { InboxButton } from '#src/components/inbox/InboxButton/index.tsx';

const Notifications = lazy(
  async () => import('#src/components/notification/Notifications/index.tsx'),
  'Notifications'
);

const NavigationCart = lazy(
  async () => import('@sorare/marketplace/src/components/cart/NavigationCart'),
  'NavigationCart'
);

const NavigationSorareWheel = lazy(
  async () =>
    import('@sorare/marketplace/src/components/Wheel/NavigationSorareWheel'),
  'NavigationSorareWheel'
);

const root = css`
  position: relative;
  border-bottom: 1px solid var(--c-ui-primary);
  padding: var(--intermediate-unit) var(--double-and-a-half-unit);
`;

type Props = { extraHeaderButton?: ReactNode };
export const DesktopWebAppHeader = ({ extraHeaderButton }: Props) => {
  const { sport } = useSportContext();
  const seriesNav = useSeriesNav();

  return (
    <Horizontal className={root} justify="end">
      <Horizontal className="max-w-full" gap={2} grow>
        <div className="w-full" id="page-header-title" />
        <div id="page-header-title-breadcrumb" />
        <Horizontal
          className="ml-auto"
          gap={0.5}
          id="page-header-right-button"
        />
      </Horizontal>
      {extraHeaderButton}
      <NavigationSorareWheel />
      <Suspense fallback={null}>
        <NavigationCart />
        {!seriesNav && <Notifications />}
      </Suspense>
      {!!seriesNav && <InboxButton />}
      <UserNav sport={sport} />
    </Horizontal>
  );
};
